import store from 'store2'

const REGISTER_GROUP_KEY = 'register-group'

export function setGroupKey (presenterLogin) {
  store.session.set(REGISTER_GROUP_KEY, presenterLogin)
}

export function getGroupKey (presenterLogin) {
  const cache = store.session.get(REGISTER_GROUP_KEY)

  if (cache?.presenter === presenterLogin) {
    return cache.groupKey
  } else {
    return undefined
  }
}
